<div class="panel-layout-container">
  <div class="panel-layout-header">
    <div class="panel-layout-title">
      <ng-content select="panel-title" />
    </div>
  </div>

  <div class="panel-layout-body">
    <ng-content select="panel-body" />
  </div>

  <div class="panel-layout-footer">
    <ng-content select="panel-footer" />
  </div>
</div>
